import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StateService} from "@uirouter/core";
import {AppAlertService, SubtitlesService} from "../core";
import {ForgotPasswordService} from "../core/forgot-password.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
    resetPasswordVisibility = false;
    newPassword: string;
    newPasswordRepeat: string;
    private subtitlesSubscription: Subscription;

    constructor(
        private http: HttpClient,
        private $state: StateService,
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
        private forgotPassword: ForgotPasswordService
    ) {
    }

    ngOnInit(): void {
        this.subtitlesSubscription = this.subtitles.subtitlesChanged$.subscribe(() => {
            if (this.subtitles.downloaded) {
                this.setResetVisibility(true);
            }
        });

        this.forgotPassword.getUrl();
    }

    ngOnDestroy() {
        if (this.subtitlesSubscription) {
            this.subtitlesSubscription.unsubscribe();
        }
    }

    setResetVisibility(visible: boolean) {
        this.resetPasswordVisibility = visible;
    }

    goLogin(): void {
        this.$state.go('login');
    }

    subtitle(id: number): string {
        return this.subtitles.setSubtitle(id);
    }

    sendNewPassword(): void {
        if (this.newPassword !== this.newPasswordRepeat) {
            this.appAlert.showAppAlert(this.subtitle(1341), this.subtitle(1136), null, false, null);
            return;
        }

        if (this.newPassword.length < 8) {
            this.appAlert.showAppAlert(this.subtitle(1147), this.subtitle(1136), null, false, null);
            return;
        }

        const data = {
            password: this.newPassword,
            reset_password_id: this.forgotPassword.url_id
        };

        this.http.put('/api/v1/account/password', data)
            .subscribe({
                next: (response: any) => {
                    switch (response.status) {
                        case '-3':
                            this.setResetVisibility(false);
                            this.appAlert.showAppAlert(this.subtitle(1942), this.subtitle(1136), this.goLogin.bind(this), false, null);
                            break;
                        case '-1':
                        case '-2':
                            this.setResetVisibility(false);
                            this.appAlert.showAppAlert(this.subtitle(1941), this.subtitle(1136), this.setResetVisibility.bind(this, true), false, null);
                            break;
                        case '1':
                            this.setResetVisibility(false);
                            this.appAlert.showAppAlert(this.subtitle(1940), this.subtitle(1129), this.goLogin.bind(this), false, null);
                            break;
                    }
                }
            });
    }
}
